import * as React from "react";
import * as ReactDOM from "react-dom";
export interface SortableListProps<T> extends React.Props<SortableListControl<T>> {
    itemTemplate(data: T): JSX.Element;
    getItemId(item: T): string;
    prepend(src: T, target: T) : void;
    data: T[]
}


export class SortableListControl<T> extends React.Component<SortableListProps<T>, any> {
    constructor(props: SortableListProps<T>) {
        super(props);
    }

    private dragOver(x: React.DragEvent<any>, item: T) {
        x.dataTransfer.dropEffect = 'move';
        x.preventDefault();
    }

    private dropAt(x: React.DragEvent<any>, target: T) {
        x.preventDefault();
        x.dataTransfer.dropEffect = "move"
        const srcId = x.dataTransfer.getData('source');
        const src = _.find(this.props.data, item => srcId === this.props.getItemId(item));
        const targetId = this.props.getItemId(target);
        //console.log(`move item ${src['Name'] || srcId} in front of ${target['Name'] || targetId}`);
        this.props.prepend(src, target);
    }

    private startDrag(x: React.DragEvent<any>, item: T) {
        x.dataTransfer.setData('source', this.props.getItemId(item));
        x.dataTransfer.effectAllowed = "move";
    }

    public render() : JSX.Element {
        return (
            <ul className="sortable-list">
                {
                    _.map(this.props.data, (item: T) =>
                        (<li className="draggable" draggable={true}
                            key={this.props.getItemId(item)}
                            onDragStart={x => this.startDrag(x, item) }
                            onDrop={x => this.dropAt(x, item) }
                            onDragOver={ x => this.dragOver(x, item) }
                            >
                            { this.props.itemTemplate(item) }
                        </li>))
                }
            </ul>);
    }
}  



// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Views/SortableListControl.tsx